// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.bs.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.bs.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var PromiseUtils$SmartcutsMacros = require("../../bs-utils/src/PromiseUtils.bs.js");

function Make(Record) {
  var currentLock = {
    contents: undefined
  };
  var releaseLock = function (param) {
    var match = currentLock.contents;
    var tmp;
    if (match !== undefined && match) {
      var nReading = match._0;
      tmp = nReading !== 1 ? /* ReadLock */({
            _0: nReading - 1 | 0
          }) : undefined;
    } else {
      tmp = undefined;
    }
    currentLock.contents = tmp;
    
  };
  var waitForLock = function (doesWrite) {
    var match = currentLock.contents;
    if (match !== undefined) {
      if (match && !doesWrite) {
        currentLock.contents = /* ReadLock */{
          _0: match._0 + 1 | 0
        };
        return Promise.resolve(undefined);
      }
      
    } else {
      currentLock.contents = doesWrite ? /* WriteLock */0 : /* ReadLock */({
            _0: 1
          });
      return Promise.resolve(undefined);
    }
    return Util$SmartcutsMacros.waitFor(1000.0, undefined, (function (param) {
                    if (currentLock.contents !== undefined) {
                      return ;
                    } else {
                      return Caml_option.some(undefined);
                    }
                  }), (function (param) {
                    throw {
                          RE_EXN_ID: Util$SmartcutsMacros.WaitFor.TimedOut,
                          _1: 1000.0,
                          Error: new Error()
                        };
                  }), undefined).then(function (param) {
                currentLock.contents = doesWrite ? /* WriteLock */0 : /* ReadLock */({
                      _0: 1
                    });
                return Promise.resolve(undefined);
              });
  };
  var withLock = function (doesWrite, f) {
    return PromiseUtils$SmartcutsMacros.resolveWith((function (result) {
                  releaseLock(undefined);
                  return result;
                }), waitForLock(doesWrite).then(Curry.__1(f)));
  };
  var get = function (param) {
    return withLock(false, (function (param) {
                  return PromiseUtils$SmartcutsMacros.resolveWith((function (results) {
                                var json = Js_dict.get(results, Record.name);
                                if (json === undefined) {
                                  return [];
                                }
                                try {
                                  return Json_decode.array(Json_decode.string, Caml_option.valFromOption(json));
                                }
                                catch (exn){
                                  return [];
                                }
                              }), browser.storage.local.get([Record.name]));
                }));
  };
  var save = function (indexes) {
    return withLock(true, (function (param) {
                  return browser.storage.local.set(Json_encode.object_({
                                  hd: [
                                    Record.name,
                                    Json_encode.array((function (prim) {
                                            return prim;
                                          }), indexes)
                                  ],
                                  tl: /* [] */0
                                }));
                }));
  };
  var create = function (newIds) {
    return get(undefined).then(function (ids) {
                return save($$Array.append(newIds, ids));
              });
  };
  var storageKey = function (id) {
    return Record.name + (":" + id);
  };
  var saveRecord = function (record) {
    var id = Curry._1(Record.idGet, record);
    return browser.storage.local.set(Json_encode.object_({
                      hd: [
                        storageKey(id),
                        Curry._1(Record.t_encode, record)
                      ],
                      tl: /* [] */0
                    })).then(function (param) {
                return Promise.resolve(id);
              });
  };
  var decode = function (json) {
    var record = Curry._1(Record.t_decode, json);
    if (record.TAG === /* Ok */0) {
      return Caml_option.some(record._0);
    }
    
  };
  var all = function (param) {
    return get(undefined).then(function (ids) {
                var storageKeys = $$Array.map(storageKey, ids);
                return PromiseUtils$SmartcutsMacros.resolveWith((function (result) {
                              return Belt_Array.keepMap(storageKeys, (function (storageKey) {
                                            return Belt_Option.flatMap(Js_dict.get(result, storageKey), decode);
                                          }));
                            }), browser.storage.local.get(storageKeys));
              });
  };
  var findById = function (id) {
    var storageKey$1 = storageKey(id);
    return PromiseUtils$SmartcutsMacros.resolveWith((function (result) {
                  return Belt_Option.flatMap(Js_dict.get(result, storageKey$1), decode);
                }), browser.storage.local.get([storageKey$1]));
  };
  var saveMany = function (recordsToAdd) {
    return Promise.all($$Array.map(saveRecord, recordsToAdd)).then(create);
  };
  var updateById = function (id, f) {
    return findById(id).then(function (maybeRecord) {
                  return saveRecord(Curry._1(f, OptionUtils$SmartcutsMacros.getExn("Expect to find storage item key=" + storageKey(id), maybeRecord)));
                }).then(function (_id) {
                return Promise.resolve(undefined);
              });
  };
  var upsert = function (record) {
    var id = Curry._1(Record.idGet, record);
    var storageKey$1 = storageKey(id);
    return browser.storage.local.get([storageKey$1]).then(function (result) {
                var shouldCreateIndex = Belt_Option.isNone(Js_dict.get(result, storageKey$1));
                return saveRecord(record).then(function (index) {
                            if (shouldCreateIndex) {
                              return create([index]);
                            } else {
                              return Promise.resolve(undefined);
                            }
                          });
              });
  };
  var deleteByIds = function (ids) {
    return browser.storage.local.remove($$Array.map(storageKey, ids)).then(function (param) {
                return get(undefined).then(function (indexes) {
                            return save(Belt_Array.keep(indexes, (function (id) {
                                              return !$$Array.mem(id, ids);
                                            })));
                          });
              });
  };
  var decode$1 = function (json) {
    var record = Curry._1(Record.t_decode, json);
    if (record.TAG === /* Ok */0) {
      return {
              TAG: /* OldType_record */0,
              _0: record._0
            };
    }
    try {
      return {
              TAG: /* NewType_id */1,
              _0: Json_decode.string(json)
            };
    }
    catch (raw_error){
      var error = Caml_js_exceptions.internalToOCamlException(raw_error);
      console.error(error);
      return ;
    }
  };
  var decodeRecordOnly = function (json) {
    var match = decode$1(json);
    if (match !== undefined && match.TAG === /* OldType_record */0) {
      return Caml_option.some(match._0);
    }
    
  };
  var migrate = function (param) {
    return browser.storage.local.get([Record.name]).then(function (results) {
                var json = Js_dict.get(results, Record.name);
                var records;
                if (json !== undefined) {
                  var array;
                  try {
                    array = Json_decode.array(decodeRecordOnly, Caml_option.valFromOption(json));
                  }
                  catch (raw_error){
                    var error = Caml_js_exceptions.internalToOCamlException(raw_error);
                    console.error(error);
                    array = [];
                  }
                  records = ArrayUtils$SmartcutsMacros.filterMap((function (x) {
                          return x;
                        }), array);
                } else {
                  records = [];
                }
                if (records.length !== 0) {
                  return Promise.all($$Array.map(saveRecord, records)).then(create);
                } else {
                  return Promise.resolve(undefined);
                }
              });
  };
  return {
          all: all,
          findById: findById,
          saveMany: saveMany,
          updateById: updateById,
          upsert: upsert,
          deleteByIds: deleteByIds,
          migrate: migrate
        };
}

exports.Make = Make;
/* Util-SmartcutsMacros Not a pure module */
